<template>
  <div>
    <BreadCrumb
      :path="[
        {
          title: `${userData.display_name}`,
        },
        {
          title: title,
          route: '/account',
        },
      ]"
    />
    <MainContentPanel
      :title="title"
      :buttonText="'Save changes'"
      :buttonAction="submitForm"
      :buttonActionLoading="savingStatus"
      :tooltip="'Save'"
      :btnDisable="btnDisable"
    >
      <div class="uk-flex uk-flex-between">
        <form class="uk-flex uk-flex-column width-xl uk-width-1-2@l uk-width-3-4@m uk-width-1-1@s">
          <p class="uk-text-bold uk-text-large uk-text-secondary">Contact:</p>
          <template v-for="f in Object.keys(formFields)" :key="f">
            <form-group
              class="uk-margin uk-flex uk-flex-between uk-flex-column"
              :class="{ error: v$.form[f].$error }"
              :validator="v$.form[f]"
            >
              <div class="uk-flex uk-flex-between" id="form-err">
                <div>
                  <span class="uk-text-bolder uk-text-large uk-text-secondary heading-font"
                    >{{ formFields[f].header }}:</span
                  >
                </div>

                <span class="uk-inline uk-width-2-3">
                  <span
                    v-if="formFields[f].icon"
                    class="uk-form-icon"
                    :uk-icon="`icon: ${formFields[f].icon}`"
                  />
                  <input
                    class="uk-input"
                    :type="formFields[f].type"
                    :placeholder="formFields[f].placeholder"
                    v-model="form[f]"
                    required
                    @input="v$.form[f].$touch()"
                    @keyup="SaveBtnDisable"
                  />
                </span>
              </div>
            </form-group>
          </template>
          <span class="uk-flex uk-flex-between">
            <div class="uk-flex uk-flex-middle">
              <span
                class="uk-text-bolder uk-text-large uk-flex uk-margin-top uk-text-secondary heading-font"
              >
                Phone/Text:
              </span>
            </div>

            <vue-tel-input
              class="uk-width-2-3 uk-margin-top phone-max-width"
              v-model="form.phone"
              @input="SaveBtnDisable"
              mode="international"
              default-country="US"
              :input-options="{
                placeholder: 'Mobile number',
              }"
              :style-classes="['vue-tel-input-custom']"
            />
          </span>
        </form>
        <form class="uk-flex uk-flex-column width-xl uk-width-1-2@l uk-width-3-4@m uk-width-1-1@s">
          <p class="uk-text-bold uk-text-large uk-text-secondary">Expertise:</p>
          <template v-for="f in Object.keys(formFields2)" :key="f">
            <form-group
              class="uk-margin uk-flex uk-flex-between uk-flex-column"
              :class="{ error: v$.form.socialMedia[f].$error }"
              :validator="v$.form.socialMedia[f]"
            >
              <div class="uk-flex uk-flex-between">
                <div class="uk-width-1-3">
                  <span
                    class="social-icons"
                    v-if="formFields2[f].icon"
                    :uk-icon="`icon: ${formFields2[f].icon}`"
                  />
                  <span
                    class="uk-text-bolder uk-text-large uk-text-secondary heading-font"
                    v-text="`${formFields2[f].header}`"
                  />
                </div>
                <!-- <span v-if="f === 'myWebsite'" class="uk-inline uk-width-2-3">
                <input 
                  class="uk-input uk-width-1-5"
                  :type="formFields2[f].type"
                  value="http://"
                  disabled
                />
                <input 
                  class="uk-input uk-width-4-5"
                  :type="formFields2[f].type"
                  :placeholder="formFields2[f].placeholder"
                  v-model="form.socialMedia[f]"
                  required
                  @input="v$.form.socialMedia[f].$touch()"
                  @keyup="SaveBtnDisable"
                />
              </span>  -->
                <span class="uk-inline uk-width-2-3">
                  <input
                    class="uk-input"
                    :type="formFields2[f].type"
                    :placeholder="formFields2[f].placeholder"
                    v-model="form.socialMedia[f]"
                    required
                    @input="v$.form.socialMedia[f].$touch()"
                    @keyup="SaveBtnDisable"
                  />
                </span>
              </div>
            </form-group>
          </template>
        </form>
      </div>
    </MainContentPanel>
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import MainContentPanel from '@/components/display/general/MainContentPanel';
import LoadingStatus from '@/assets/js/enum/LoadingStatus';
import { VueTelInput } from 'vue-tel-input';
import BreadCrumb from '@/components/general/BreadCrumb';
import 'vue-tel-input/vue-tel-input.css';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { email, required, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { xhr } from '@/xhr/endpoints';
import { transformUserDataForUpdate } from '@/assets/js/utils';
const customUrl = helpers.regex(
  /^(http(s)?:\/\/.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)$/
);
export default {
  name: 'AccountDetails',
  components: {
    MainContentPanel,
    VueTelInput,
    BreadCrumb,
  },
  setup() {
    const form = reactive({
      name: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      socialMedia: {
        myWebsite: '',
        twitterId: '',
        linkedInId: '',
        myAffiliation: '',
        affiliationSite: '',
      },
    });

    const rules = computed(() => ({
      form: {
        name: { required },
        firstName: { required },
        lastName: { required },
        email: { email, required },
        phone: {},
        socialMedia: {
          myWebsite: { customUrl },
          affiliationSite: { customUrl },
          twitterId: {},
          linkedInId: {},
          myAffiliation: {},
        },
      },
    }));

    const v$ = useVuelidate(rules, { form });

    return { form, v$: v$.value };
  },
  data() {
    return {
      title: 'MyAccount',
      personData: {},
      formFields: {
        name: {
          type: 'text',
          icon: 'user',
          header: 'Display Name',
          placeholder: 'Display Name',
          required: true,
        },
        firstName: {
          type: 'text',
          icon: 'user',
          header: 'First Name',
          placeholder: 'FirstName ',
          required: true,
        },
        lastName: {
          type: 'text',
          icon: 'user',
          header: 'Last Name',
          placeholder: 'LastName',
          required: true,
        },
        email: {
          type: 'email',
          icon: 'mail',
          header: 'Email',
          placeholder: 'Email Address',
          required: true,
        },
      },
      formFields2: {
        linkedInId: {
          type: 'text',
          icon: 'linkedin',
          header: 'LinkedIn:',
          placeholder: 'Enter your LinkedIn URL',
        },
        twitterId: {
          type: 'text',
          icon: 'twitter',
          header: 'X (fka Twitter):',
          placeholder: 'Enter your Twitter ID',
        },
        myAffiliation: {
          type: 'text',
          header: 'My Affiliation: ',
          placeholder: "Enter your organization's name",
        },
        affiliationSite: {
          type: 'text',
          header: 'Affiliation Site: ',
          placeholder: "Enter your organization's website",
        },
        myWebsite: {
          type: 'text',
          header: 'My Site: ',
          placeholder: 'Enter your professional website',
        },
      },
      savingStatus: '',
      btnDisable: true,
    };
  },
  computed: {
    ...mapState(['idToken', 'userData']),
    ...mapGetters([]),
  },
  created() {
    this.form.name = this.userData.display_name;
    this.form.firstName = this.userData.first_name;
    this.form.lastName = this.userData.last_name;
    this.form.email = this.userData.emails[0];
    this.form.socialMedia.myWebsite = this.userData.my_website;
    this.form.socialMedia.twitterId = this.userData.twitter_id;
    this.form.socialMedia.linkedInId = this.userData.linkedin_id;
    this.form.socialMedia.myAffiliation = this.userData.my_affiliation;
    this.form.socialMedia.affiliationSite = this.userData.affiliation_site;
    this.form.phone =
      this.userData.phone_numbers && this.userData.phone_numbers.length != 0
        ? this.userData.phone_numbers[0]
        : '';
  },
  methods: {
    ...mapMutations(['setUserData']),
    ...mapActions(['showSavingLoader', 'hideLoader']),

    async submitForm() {
      this.v$.form.$touch();
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.savingStatus = LoadingStatus.LOADING;
      await this.edit();
      this.btnDisable = true;
    },
    SaveBtnDisable() {
      this.btnDisable = false;
    },
    async edit() {
      try {
        const userObj = {
          display_name: this.form.name,
          firstname: this.form.firstName,
          lastname: this.form.lastName,
          emails: [this.form.email],
          phoneNumbers: [this.form.phone],
          twitterId: this.form.socialMedia.twitterId,
          linkedInId: this.form.socialMedia.linkedInId,
          myWebsite: this.form.socialMedia.myWebsite,
          myAffiliation: this.form.socialMedia.myAffiliation,
          affiliationSite: this.form.socialMedia.affiliationSite,
        };
        await xhr
          .updateMyUser(userObj, this.idToken)
          .then(res => {
            if (res._id) {
              this.savingStatus = LoadingStatus.NONE;
              let data = transformUserDataForUpdate(res);
              this.setUserData(data);
            } else this.savingStatus = LoadingStatus.FAILED;
          })
          .catch(err => {
            console.log(err);
            this.savingStatus = LoadingStatus.FAILED;
          });
      } catch (err) {
        this.savingStatus = LoadingStatus.FAILED;
        console.log(err);
      }
    },
  },
};
</script>

<style lang="sass">
.error
  input
    border-color: red

.phone-max-width
  max-width: 100% !important

.social-icons
  width: 24px  !important
  background: #254858  !important
  color: white  !important
  border-radius: 50%  !important
  padding: 5px  !important
  vertical-align: text-bottom
  margin: 1px 10px 2px 0px !important

#form-err + div
  margin-left: 33%

.form-error
  color: red
  display: flex

.width-xl
  @media (min-width: 1600px)
    width: 45% !important
  @media (max-width: 1600px)
    width: 44% !important
  @media (max-width: 1380px)
    width: 47% !important
  @media (max-width: 1170px)
    width: 48% !important

.heading-font
  @media (max-width: 1660px)
    font-size: $global-large-font-size !important
  @media (max-width: 1600px)
    font-size: $global-font-size !important
  @media (max-width: 1380px)
    font-size: $global-small-font-size !important
  @media (max-width: 1170px)
    font-size: $global-small-font-size !important
  @media (max-width: 1065px)
    font-size: 0.625rem !important
</style>
